import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface AssignPayPalStoreAccountPayload {
  storeId: number;
  paypalMerchantAccountId: number;
}

/**
 * Replaces the store's active assignment, if any. CentsBE answers 409 when the merchant account
 * belongs to a different business than the store.
 */
export const assignPayPalStoreAccount = ({
  storeId,
  paypalMerchantAccountId,
}: AssignPayPalStoreAccountPayload): AxiosPromise<{ success: boolean }> => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/stores/${storeId}/paypal-account`,
    data: {
      paypalMerchantAccountId,
    },
  });
};
